import { STAFF_STATE } from 'apps/ff-frontend/src/app/state/app.state';
import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { StyleClassModule } from 'primeng/styleclass';
import { STAFFINTERFACE, STATE_STAFF_LIST } from '@fitness-force/models';
import { TranslateModule } from '@ngx-translate/core';
import { AuthSevices } from '@fitness-force/api';
import { SelectItemGroup } from 'primeng/api';

@Component({
  selector: 'multi-select-staff',
  templateUrl: './multi-select-staff.component.html',
  styleUrls: ['./multi-select-staff.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MultiSelectModule,
    FormsModule,
    ReactiveFormsModule,
    StyleClassModule,
    TranslateModule
  ]
})
export class MultiSelectStaffComponent implements OnInit {
  @Input('selected') selected: number[] = [];
  @Input ('placeholder') placeholder :string ='ADMIN.COMMON.SELECT_STAFF';
  selectedFilter: { name: string; } | undefined;
  allStaffs$ = new BehaviorSubject<SelectItemGroup[]>([])
  selectedStaffList: UntypedFormGroup = new UntypedFormGroup({})
  @Output() selectStaffEvent = new EventEmitter();

  disabledDropdown:boolean = false;

  statusOptions: any[] = [
    { label: 'Invited', value: 'Invited' },
    { label: 'Active', value: 'Active' },
    { label: 'Suspended', value: 'Suspended' },
    { label: 'Terminated', value: 'Terminated' },
  ];

  nestedArray: SelectItemGroup[];
  constructor(private store: Store, private fb: UntypedFormBuilder, private authService: AuthSevices) { }

  ngOnInit(): void {
    this.selectedStaffList = this.fb.group({
      selectedStaffs: []
    })
    this.loadStaffList();
  }


  loadStaffList() {
    this.store.select(STAFF_STATE).subscribe((s: STATE_STAFF_LIST) => {
      const all = s.staffList;  //s.staffList.filter((val: STAFFINTERFACE) => (!val?.is_system_staff));
      this.nestedArray=[];
      
      if (all && all.length > 0) {
        if (this.authService.currentUser == "Admin") {
          this.statusOptions.forEach((status) => {
            const staffs = all.filter((item) => item.status === status.value);
            if (staffs.length > 0) {
              let group:SelectItemGroup={} as SelectItemGroup;
              group.label = status.label;
              group.items =[];
              staffs.forEach(o => {
                group.items.push({ 'label':o.name ,'value': o,disabled:false})
              });
              this.nestedArray.push(group);
            }
          });

          if(this.nestedArray.length == 1)
          {
            this.nestedArray.forEach(element => {
              if(element.items.length>0)
              {
                if(element.items.length == 1)
                {
                  element.items.forEach((staff) => {
                    staff.disabled = true;
                  });
                  this.disabledDropdown = true;
                }
              }
            });
          }

          this.allStaffs$.next(this.nestedArray);
        } else {
          var temp: STAFFINTERFACE[] = [];
          var currentUserDetails = this.authService.decodedToken;
          if(currentUserDetails && (currentUserDetails['can_admin_client_profiles'] =='true ' || currentUserDetails['can_manage_client_profiles'] == 'true'))
          {
            temp = all;
          }
          else{
            all.forEach((staff: STAFFINTERFACE) => {
              if ( (staff.reports_to_id != null && (staff.reports_to_id.toString() ==  currentUserDetails.Id)) 
                  ) {
                temp.push(staff);
              }
            });
            if (!temp.find((staff: STAFFINTERFACE) => (staff.id.toString() == currentUserDetails.Id))) {
              const currentUser = all.find((staff: STAFFINTERFACE) => (staff.id.toString() == currentUserDetails.Id))
              if (currentUser) temp.push(currentUser);
            }
          }
          
          this.statusOptions.forEach((status) => {
            const staffs = temp.filter((item) => item.status === status.value);
            if (staffs.length > 0) {
              let group:SelectItemGroup={} as SelectItemGroup;
              group.label = status.label;
              group.items =[];
              staffs.forEach(o => {
                group.items.push({ 'label':o.name ,'value': o,disabled:false})
              });
              this.nestedArray.push(group);
            }
          });
          if(this.nestedArray.length == 1)
            {
              this.nestedArray.forEach(element => {
                if(element.items.length>0)
                {
                  if(element.items.length == 1)
                  {
                    element.items.forEach((staff) => {
                      staff.disabled = true;
                    });
                    this.disabledDropdown = true;
                  }
                }
              });
            }
          this.allStaffs$.next(temp as any);
        }
      }

      if (all && all.length > 0 && this.selected && this.selected.length > 0) {
        const staffs: STAFFINTERFACE[] = [];
        all.forEach((staff: STAFFINTERFACE) => {
          if (this.selected.includes(staff.id)) {
            staffs.push(staff);
          }
        });
        this.selectedStaffList.get('selectedStaffs')?.setValue(staffs)
      }
    })
  }


  // Run this on exchange
  setSelectedStaff(allList: STAFFINTERFACE[]) {
    const tempSelected: STAFFINTERFACE[] = [];
    allList.forEach((elm: STAFFINTERFACE) => {
      if (this.selected.includes(elm.id)) {
        tempSelected.push(elm);
      }
    });
    this.selectedStaffs.setValue(tempSelected);
  }

  get selectedStaffs(): UntypedFormControl {
    return this.selectedStaffList.get('selectedStaffs') as UntypedFormControl
  }
  
  getSelectedStaff(e: any) {
    this.selectStaffEvent.emit(this.selectedStaffs.value)
  }
  
  selectAll() {
    this.selectedStaffs.setValue(this.allStaffs$.value);
    this.selectStaffEvent.emit(this.selectedStaffs.value)
  }
}